import ProfileModel from './profile-model';
import doeProfile from './profile-pictures/doe.jpeg'

const doe = new ProfileModel({
    username: 'doe',
    password: 'admin',
    profilePicture: doeProfile,
    firstName: 'May',
    lastName: 'Doe',
    files: ['test'],
    key: 1,
})

export default doe;